import { render } from "./PassordForgottenModal.vue?vue&type=template&id=615498bd&scoped=true"
import script from "./PassordForgottenModal.vue?vue&type=script&lang=js"
export * from "./PassordForgottenModal.vue?vue&type=script&lang=js"

import "./PassordForgottenModal.vue?vue&type=style&index=0&id=615498bd&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615498bd"]])

export default __exports__